export enum LocalStorage {
  browserId = "browserId",
  productBannerInfo = "productBannerInfo",
  investmentProductBannerInfo = "investmentProductBannerInfo",
  scrollingLeft = "scrollingLeft",
  scrollingTop = "scrollingTop",
  SubscriptionBannersHidden = "subscriptionBannersHidden",
  PlatformAnalysisReachAnalysisSetupPage = "platformAnalysisReachAnalysisSetupPage",
}
